/*global MONTHS*/
import { MONTHS } from './finish-case-dialog';
export function addComment(entityId, action) {
    var commentText = document.getElementById('comment-text').value;
    var request;
    if (action === 'MaintenanceAction') {
        request = {
            url: '/atgard/kommentera',
            data: { text: commentText, actionId: entityId }
        };
    }
    else if (action === 'GardenSpot') {
        request = {
            url: '/min-tradgard/vaxtplats/kommentera',
            data: { text: commentText, gardenSpotId: entityId, '__RequestVerificationToken': $('.js-anti-forgery' + ' input').val() }
        };
    }
    else if (action === 'PlantType') {
        request = {
            url: '/min-tradgard/vaxttyp/kommentera',
            data: { text: commentText, plantTypeId: entityId, '__RequestVerificationToken': $('.js-anti-forgery' + ' input').val() }
        };
    }
    else {
        request = {
            url: '/kontroll/kommentera',
            data: { text: commentText, componentId: entityId }
        };
    }
    var deleteCommentName = 'ts-delete-comment';
    if (action === 'GardenSpot') {
        deleteCommentName = 'ts-delete-comment-garden-spot';
    }
    else if (action === 'PlantType') {
        deleteCommentName = 'ts-delete-comment-plant-type';
    }
    $.post(request).done(function (commentId) {
        var today = new Date();
        var dateString = today.getDate() + ' ' + MONTHS[today.getMonth()] + ' ' + today.getFullYear();
        var html = '<div class="comment-box" id="comment-' + commentId + '">' +
            '<a data-commentid="' + commentId + '"' + 'class="comment-box__delete-icon ' + deleteCommentName + '">' +
            '<img src="/images/icons/delete.svg" class="icon" alt="Ta bort">' +
            '</a>' +
            '<div class="comment-box__date">' + dateString + '</div>' +
            '<p class="comment-box__text">' + commentText + '</p>' +
            '</div>';
        $('#comments-container').prepend(html);
        document.getElementById('comment-text').value = '';
    });
    $('.ts-comment-section').removeClass('hidden');
}
$('.ts-add-inspection-comment').on('click', function () {
    var entityId = $(this).data('actionid');
    addComment(entityId, '');
});
$('#comments-container').on('click', '.ts-delete-comment', function () {
    var commentId = $(this).data('commentid');
    deleteComment(commentId);
});
function deleteComment(commentId) {
    $.post({
        url: '/kontroll/radera-kommentar',
        data: { commentId: commentId }
    }).done(function (response) {
        var element = document.getElementById('comment-' + commentId);
        if (element) {
            element.outerHTML = '';
        }
    });
}
$('.ts-toggle-action-active-status').on('click', function () {
    toggleActionActiveStatus($(this).data('housecomponentid'), $(this).data('gtmlabel'), false);
});
export function toggleActionActiveStatus(entityId, label, onMaintenanceAction) {
    var request;
    if (onMaintenanceAction) {
        request = {
            url: '/atgard/vaxla-status',
            data: { actionId: entityId }
        };
    }
    else {
        request = {
            url: '/kontroll/vaxla-status',
            data: { componentId: entityId }
        };
    }
    $.ajax(request).done(function (response) {
        // HACK: Always true?
        if (response.active !== null) {
            var toggleActiveButton = $('#toggle-active-button');
            toggleActiveButton.toggleClass('button--blured');
            toggleActiveButton.children().toggleClass('hidden');
            var toogleBarText = $('#action-active-status');
            toogleBarText.toggleClass('hidden');
            var categoryName = onMaintenanceAction ? 'Maintenance' : 'Inspection';
            var category = 'MV ' + categoryName;
            var actionName = response.active ? 'started' : 'canceled';
            var action = categoryName + ' ' + actionName;
            window['dataLayer'].push({
                'event': 'MinVilla_Started',
                'eventCategory': category,
                'eventAction': action,
                'eventLabel': label
            });
        }
    });
}
$('.ts-case-start-toggle-btn').on('click', function () {
    $(this).find('.toggle-switch').toggleClass('active');
    $('.ts-container-finish').toggleClass('hidden');
});
$('#show-all-comments-link').on('click', function () {
    $('#show-all-comments-link').prop('hidden', true);
    $('.comment-box.hidden').removeClass('hidden');
});
var actionFileArea = $('.ts-action-file-area');
var actionFileAreaBtn = $('.ts-action-file-area-btn');
var actionCommentArea = $('.ts-action-comment-area');
var actionCommentAreaBtn = $('.ts-action-comment-area-btn');
actionFileAreaBtn.on('click', function () {
    actionFileArea.toggleClass('hidden');
    actionCommentArea.addClass('hidden');
    actionCommentAreaBtn.removeClass('active');
    actionFileAreaBtn.toggleClass('active');
});
actionCommentAreaBtn.on('click', function () {
    actionFileArea.addClass('hidden');
    actionFileAreaBtn.removeClass('active');
    actionCommentArea.toggleClass('hidden');
    actionCommentAreaBtn.toggleClass('active');
});
